import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Movies from "../movies/Movies";
import Tv from "../tv-series/Tv";
import Anime from "../anime/Anime";

import "./TabSlider.scss";

const LabTabs = ({ setValue, value }) => {
  // const [value, setValue] = React.useState("2");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", paddingTop: "10px", height: "inherit" }}>
      <TabContext value={value}>
        <Box sx={{}}>
          <TabList onChange={handleChange}>
            <Tab label="TV Series" value="1" />
            <Tab label="Movies" value="2" />
            <Tab label="Animes" value="3" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <div>
            <Tv setValue={setValue} />
          </div>
        </TabPanel>
        <TabPanel value="2">
          <div>
            <Movies setValue={setValue} />
          </div>
        </TabPanel>
        <TabPanel value="3">
          <Anime setValue={setValue} />
        </TabPanel>
      </TabContext>
    </Box>
  );
};
export default LabTabs;
